module.exports = __webpack_public_path__ + "assets/d2f1ffd0df4fdda164d2a1d979be4e48.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo-transparent-blank.png
// module id = 885
// module chunks = 0